// extracted by mini-css-extract-plugin
export default {"header":"Header_header__gsCSA","title":"Header_title__CqPDt","logo":"Header_logo__R3an4"};